<template>
  <div class="error-view">
    <div class="nav-bar-header">
      <a href="https://www.lojapecasoriginais.com.br/pt/">
        <img src="@/assets/w-b-c-logo.jpg" alt="Whirlpool" />
      </a>
    </div>
    <div class="nav-bar-background"></div>
    <div class="container">
      <p>
        Usuário não cadastrado, favor entrar em contato no<br />
        e-mail:
        <a href="mailto:gcg-devolucao_comercial@whirlpool.com">
          gcg-devolucao_comercial@whirlpool.com
        </a>
      </p>
    </div>
  </div>
</template>

<script>
import HomeFooter from "@/components/home/HomeFooter.vue";
export default {
  name: "error",
  components: {
    HomeFooter
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/_colors.scss";
.error-view {
  display: block;
  .nav-bar-header {
    background-color: $white;
    color: $grey2;
    padding-left: 10%;
    padding-top: 30px;
    padding-bottom: 30px;
    img {
      width: 297px;
      height: 66px;
      margin-left: -17px;
    }
  }
  .nav-bar-background {
    width: 100%;
    background-color: $grey2;
    height: 45px;
    margin-top: 0;
    border-bottom: 5px solid $orange1;
  }
  .container {
    padding: 100px 0;
    text-align: center;
    p {
      font-size: 1.5em;
    }
  }
}
</style>
